'use client'

import { Step } from '@/hooks/useAppStore'
import { QuizLayout } from './QuizLayout'
import { motion, AnimatePresence } from 'framer-motion'
import { WelcomeBackModal } from './WelcomeBackModal'
import { PhaseCelebration } from './EnhancedProgress'
import { useQuiz } from './hooks/use-quiz'

// Steps individuais
import { StepIntro } from './steps/step-intro'
import { StepNome } from './steps/step-nome'
import { StepContato } from './steps/step-contato'
import { StepPerfil } from './steps/step-perfil'
import { StepSituacao } from './steps/step-situacao'
import { StepObjetivo } from './steps/step-objetivo'
import { StepFuncionalidades } from './steps/step-funcionalidades'
import { StepBranding } from './steps/step-branding'
import { StepConteudo } from './steps/step-conteudo'
import { StepUrgencia } from './steps/step-urgencia'
import { StepDetalhes } from './steps/step-detalhes'
import { StepLgpd } from './steps/step-lgpd'
import { StepEnviando } from './steps/step-enviando'
import { StepSucesso } from './steps/step-sucesso'

export function QuizFunnel() {
  const quiz = useQuiz()

  const renderStepContent = () => {
    switch (quiz.currentStep) {
      case Step.INTRO:
        return (
          <StepIntro
            formData={quiz.formData}
            updateFormData={() => {}}
            onNext={quiz.nextStep}
            onBack={() => {}}
            personalizacao={quiz.personalization}
            isFromAds={quiz.isFromAds}
          />
        )

      case Step.NAME:
        return (
          <StepNome
            nome={quiz.nome}
            setNome={quiz.setNome}
            onSubmit={quiz.handleNomeSubmit}
            inputRef={quiz.inputRef}
          />
        )

      case Step.CONTACT:
        return (
          <StepContato
            nomeCompleto={quiz.formData.nome}
            email={quiz.email}
            setEmail={quiz.setEmail}
            telefone={quiz.telefone}
            setTelefone={quiz.setTelefone}
            erros={quiz.erros}
            setErros={quiz.setErros}
            onSubmit={quiz.handleContatoSubmit}
            onBack={quiz.prevStep}
            inputRef={quiz.inputRef}
            validandoWhatsApp={quiz.validandoWhatsApp}
            whatsappVerificado={quiz.whatsappVerificado}
          />
        )

      case Step.PROFILE:
        return (
          <StepPerfil
            empresa={quiz.empresa}
            setEmpresa={quiz.setEmpresa}
            onSubmit={quiz.handlePerfilSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.SITUATION:
        return (
          <StepSituacao
            urlAtual={quiz.urlAtual}
            setUrlAtual={quiz.setUrlAtual}
            onSubmit={quiz.handleSituacaoSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.OBJECTIVE:
        return (
          <StepObjetivo
            onSubmit={quiz.handleObjetivoSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.FEATURES:
        return (
          <StepFuncionalidades
            featuresSelecionadas={quiz.featuresSelecionadas}
            toggleFeature={quiz.toggleFeature}
            onSubmit={quiz.handleFuncionalidadesSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.BRANDING:
        return (
          <StepBranding
            coresSelecionadas={quiz.coresSelecionadas}
            toggleColor={quiz.toggleColor}
            urlReferencia={quiz.urlReferencia}
            setUrlReferencia={quiz.setUrlReferencia}
            onSubmit={quiz.handleBrandingSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.CONTENT:
        return (
          <StepConteudo
            onSubmit={quiz.handleConteudoSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.URGENCY:
        return (
          <StepUrgencia
            onSubmit={quiz.handleUrgenciaSubmit}
            onBack={quiz.prevStep}
          />
        )

      case Step.DETAILS:
        return (
          <StepDetalhes
            detalhes={quiz.detalhes}
            setDetalhes={quiz.setDetalhes}
            onSubmit={quiz.handleDetalhesSubmit}
            onSkip={quiz.handleDetalhesSkip}
            onBack={quiz.prevStep}
            textareaRef={quiz.textareaRef}
          />
        )

      case Step.LGPD:
        return (
          <StepLgpd
            nomeCompleto={quiz.formData.nome}
            lgpdAceito={quiz.lgpdAceito}
            setLgpdAceito={quiz.setLgpdAceito}
            onSubmit={quiz.handleLgpdSubmit}
            onBack={() => quiz.setStep(Step.DETAILS)}
          />
        )

      case Step.SUBMITTING:
        return <StepEnviando />

      case Step.SUCCESS:
        return <StepSucesso formData={quiz.formData} />

      default:
        return null
    }
  }

  return (
    <>
      <WelcomeBackModal
        show={quiz.showWelcomeBack}
        name={quiz.returningName || ''}
        lastStep={quiz.lastStep}
        onContinue={quiz.handleContinueFromSaved}
        onStartOver={quiz.handleStartOver}
      />

      <QuizLayout currentStep={quiz.getStepKey()} formData={quiz.formData}>
        <PhaseCelebration
          phaseName={quiz.completedPhaseName}
          show={quiz.showPhaseCelebration}
          onComplete={() => quiz.setShowPhaseCelebration(false)}
        />

        <AnimatePresence mode="wait">
          <motion.div key={quiz.currentStep} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
            {renderStepContent()}
          </motion.div>
        </AnimatePresence>
      </QuizLayout>
    </>
  )
}
